<template>
  <section v-click-outside="closeAll" class="tooltip-menu">
    <div class="tooltip-menu__head" @click="tooltipOpen = !tooltipOpen">
      <div>
        <h3 class="tooltip-menu__active">{{ activeItem.label }}</h3>
        <SvgChevron
          v-if="$route.name == 'home'"
          :class="[
            'tooltip-menu__svg',
            { 'tooltip-menu__svg--open': tooltipOpen },
          ]"
        />
      </div>
    </div>

    <div
      v-if="tooltipOpen && !$route.params.doNotOpenTopMenuOnClick"
      class="tooltip-menu__list"
    >
      <Button
        v-for="(item, index) in tooltipList"
        :key="index"
        :label="item.label"
        :is-active="item.value === activeItem.value"
        is-fluid
        @action="emitTip(item)"
      />
    </div>
  </section>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  name: 'TooltipMenu',

  directives: {
    ClickOutside,
  },

  components: {
    Button: () => import('./Button.vue'),
    //
    SvgChevron: () => import('@/assets/svgs/chevron.svg?inline'),
  },

  props: {
    tooltipList: {
      type: Array,
      default: () => [],
    },
    activeItem: {
      type: Object,
      default: () => {
        return {
          label: '',
          value: ''
        }
      },
    },
  },

  data: () => ({
    tooltipOpen: false,
  }),

  methods: {
    emitTip(x) {
      this.tooltipOpen = false;
      this.$emit('action', x);
    },
    closeAll() {
      this.tooltipOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.tooltip-menu {
  position: relative !important;

  &__head {
    @include flexbox(center, center);

    div {
      display: inline-flex;
      align-items: center;
      justify-content: flex-start;
      cursor: pointer;
    }
  }

  &__active {
    color: $white;
    font-size: rem(20);
    line-height: 1.5;
    margin: 0;
  }

  &__svg {
    width: rem(20);
    margin-left: rem(15);
    transition: $transition;

    &--open {
      transform: rotateZ(180deg);
    }
  }

  &__list {
    background: $white;
    @include flex-column;
    padding: rem(10) rem(10) rem(15);
    border-radius: 0 0 rem(15) rem(15);
    width: rem(275);
    position: absolute;
    top: rem(55);
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999 !important;
    box-shadow: 0 12px 40px -35px rgba(0, 0, 0, 0.75);

    .button {
      color: #9b9b9b;
      border: 1px solid #9b9b9b;

      &:not(:last-child) {
        margin-bottom: rem(10);
      }
    }
  }

  @include iPadProStyles {
    &__list {
      top: rem(71);

      .button {
        font-size: rem(22);
      }
    }

    &__active {
      font-size: rem(24);
    }
  }
}
</style>
